<template>
  <span>
    <RowActions :items="actions" />
    <b-modal v-model="confirmOpen" :title="pending === 'delete' ? 'حذف نرم' : 'تغییر وضعیت'" hide-footer>
      <p>{{ message }}</p>
      <p v-if="error" role="alert" class="asset-error">{{ error }}</p>
      <button type="button" class="btn accept" :disabled="busy" @click="apply">{{ busy ? 'در حال ذخیره…' : 'تأیید' }}</button>
      <button type="button" class="btn" :disabled="busy" @click="confirmOpen = false">انصراف</button>
    </b-modal>
  </span>
</template>
<script>
import RowActions from '@/components/RowActions/index.vue';
import { errorText } from '@/utils/executionAdmin';
export default {
  components: { RowActions },
  props: { kind: { type: String, required: true }, record: { type: Object, required: true }, extra: { type: Array, default: () => [] } },
  data: () => ({ confirmOpen: false, pending: '', busy: false, error: '' }),
  computed: {
    projectId() { return this.$STORE.state.userConfig.setProjectId; },
    actions() {
      return [...this.extra, ...(this.record.is_deleted ? [] : [
        ...(this.record.registration_status === 'pending' ? [{ label: 'تأیید ثبت موقت', icon: 'edit', action: () => this.ask('approve') }] : []),
        { label: 'ویرایش همه مشخصات', icon: 'edit', to: `/elevatormanagement/${this.kind}edit/${this.record.id}` },
        { label: this.record.is_active ? 'غیرفعال‌کردن' : 'فعال‌کردن', icon: 'edit', action: () => this.ask('toggle') },
        { label: 'حذف نرم', icon: 'delete', danger: true, action: () => this.ask('delete') },
      ])];
    },
    message() {
      const name = this.record.verbose_name || this.record.title || this.record.code;
      if (this.pending === 'approve') return `ثبت موقت «${name}» تأیید و به ثبت نهایی تبدیل می‌شود.`;
      if (this.pending === 'delete') return `«${name}» از فهرست عملیاتی حذف می‌شود. ${this.kind === 'building' ? 'ساختمان‌ها و آسانسورهای زیرمجموعه هم حذف نرم می‌شوند.' : ''} هیچ داده یا سابقه‌ای از دیتابیس پاک نمی‌شود.`;
      if (this.record.is_active) return `«${name}» غیرفعال می‌شود. ${this.kind === 'building' ? 'تمام ساختمان‌ها و آسانسورهای زیرمجموعه نیز غیرفعال خواهند شد.' : ''} سوابق حفظ می‌شوند.`;
      return 'رکورد فعال می‌شود؛ زیرمجموعه‌ها باید جداگانه فعال شوند و والد باید فعال باشد.';
    },
  },
  watch: { projectId() { this.confirmOpen = false; this.error = ''; } },
  methods: {
    ask(action) { this.pending = action; this.error = ''; this.confirmOpen = true; },
    async apply() {
      if (this.busy) return;
      this.busy = true; this.error = '';
      const project = this.projectId, id = this.record.id;
      try {
        const entity = this.kind === 'building' ? 'Building' : 'Elevator';
        const url = `/api/visit/${entity}Edits/${id}/?p=${project}`;
        const res = this.pending === 'approve' ? await this.$ApiServiceLayer.patch(`/core/api/admin/assets/${this.kind}/${id}/approve/?p=${project}`, '', {}) : this.pending === 'delete' ? await this.$ApiServiceLayer.delete(url, '') :
          await this.$ApiServiceLayer.patch(url, '', { is_active: !this.record.is_active });
        if (project !== this.projectId || id !== this.record.id) return;
        if (![200, 204].includes(res.status)) throw new Error(errorText(this.$ApiServiceLayer, res));
        this.confirmOpen = false; this.$emit('changed');
      } catch (e) { this.error = e.message || 'ذخیره انجام نشد.'; }
      finally { this.busy = false; }
    },
  },
};
</script>
<style scoped>.asset-error { color: #a12727; white-space: pre-wrap; }</style>
